import { createContext, useContext } from 'react';
import type { AugmentedAccount, AugmentedUser } from './types';

type Auth = {
  account: AugmentedAccount;
  user: AugmentedUser;
};

const AuthContext = createContext<Auth | null>(null);

export function AuthProvider({ children, auth }: { children: React.ReactNode; auth: Auth }) {
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === null) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
